import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import MenuItem from 'material-ui/MenuItem';
import linksConfig from 'constants/linksConfig';
import {withRouter} from 'react-router-dom';

export class Links extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            waiting: true
        };
        this.onTouchTap = this
            .onTouchTap
            .bind(this);

    }

    onTouchTap(e) {
        const {onTouchTap, linkKey, history} = this.props;
        e.preventDefault();
        onTouchTap();
        const config = linksConfig.find((link) => {
            return link.get('linkKey') === linkKey;
        });

        if (config.get('isExternal')) {
            window.open(config.get('to'), '_blank');
        } else {
            history.push(config.get('to'));
        }

    }

    render() {

        const {linkKey, isMenu} = this.props;

        const config = linksConfig.find((link) => {
            return link.get('linkKey') === linkKey;
        });

        if (!config) {
            return null;
        }

        const icon = (
            <FontIcon className="material-icons">
                {config.get('icon')}
            </FontIcon>
        );

        if (isMenu) {
            return (<MenuItem
                onTouchTap={this.onTouchTap}
                leftIcon={icon}
                primaryText={config.get('text')}/>);
        }

        return (<FlatButton
            icon={icon}
            label={config.get('text')}
            onTouchTap={this.onTouchTap}/>);

    }
}
Links.propTypes = {
    linkKey: PropTypes.string,
    isMenu: PropTypes.bool,
    onTouchTap: PropTypes.func,
    history: PropTypes.object
};

export default withRouter(Links);


// WEBPACK FOOTER //
// ./src/components/layout/Links.js